import styled from '@emotion/styled';
import React from 'react';
import { ReactNode } from 'react';
import { semantic_colors } from '../../foundation';
import { BaseText } from '../../components/text';

export interface TopNavigationProps {
  title?: ReactNode;
  leftContent?: ReactNode;
  rightContent?: ReactNode;
}

export const TopNavigation = ({ title, leftContent, rightContent }: TopNavigationProps) => {
  return (
    <Container>
      {Boolean(leftContent) && <LeftArea>{leftContent}</LeftArea>}
      {Boolean(title) && (
        <TitleText as='h1' typography='Heading_17_Bold' color={semantic_colors.content.primary}>
          {title}
        </TitleText>
      )}
      {Boolean(rightContent) && <RightArea>{rightContent}</RightArea>}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 56px;
  padding: 16px;
  background: ${semantic_colors.background.surface};
`;

const TitleText = styled(BaseText)`
  width: 100%;
  text-align: center;
  padding: 0 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const LeftArea = styled.div`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
`;
const RightArea = styled.div`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  column-gap: 8px;
  margin-left: auto;
`;
